module.exports = __webpack_public_path__ + "img/11f082b.png";